// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3unRc","imageUploader":"EGiftCard_imageUploader__3jaa8"};